import React from 'react'
import { CompanyAddCredit } from '../../../../../../services/api/companies'
import { Form, SubmitButton, DatePicker, Input, FormItem } from 'formik-antd'
import { Amount } from '../../../../../../components'
import { Formik } from 'formik'
import { Divider } from 'antd'
import moment, { Moment } from 'moment'

const { TextArea } = Input
type Form = CompanyAddCredit
type Props = {
  initialValues: Form
  format: string
  onSubmit: (form: Form, ...args: any[]) => void
}

export const View: React.FunctionComponent<Props> = ({
  initialValues,
  format,
  onSubmit,
}) => {
  const disablePastDates = (date: Moment): boolean => {
    return moment() >= date
  }

  return (
    <Formik<Form> initialValues={initialValues} onSubmit={onSubmit}>
      <Form layout="vertical" size="large">
        <FormItem name="amount" required>
          <Amount placeholder="Сумма" name="amount" />
        </FormItem>

        <FormItem name="expiredAt" required>
          <DatePicker
            name="expiredAt"
            format={format}
            picker="date"
            style={{ width: '100%' }}
            disabledDate={disablePastDates}
            showToday={false}
          />
        </FormItem>

        <FormItem name="comment" required>
          <TextArea name="comment" placeholder="Комментарий" rows={2} />
        </FormItem>

        <Divider />

        <SubmitButton>Сохранить изменения</SubmitButton>
      </Form>
    </Formik>
  )
}
